import React from 'react';
import { useHasFF } from 'venn-utils';
import LabSideBarLegacy, { SIDE_BAR_WIDTH as LEGACY_SIDE_BAR_WIDTH } from './LabSideBarLegacy';
import LabSideBarNew, { SIDE_BAR_WIDTH as NEW_SIDE_BAR_WIDTH } from './LabSideBarNew';

export interface LabSideBarProps {
  isSideBarCollapsed: boolean;
  toggleSideBarCollapsed: () => void;
  allocationSectionExpanded: boolean;
  toggleAllocationSection: () => void;
  factorSectionExpanded: boolean;
  toggleFactorSection: () => void;
  benchmarkSectionExpanded: boolean;
  toggleBenchmarkSection: () => void;
  optimizing?: boolean;
}

export const getSideBarWidth = (hasPortfolioLabFF: boolean): number =>
  hasPortfolioLabFF ? NEW_SIDE_BAR_WIDTH : LEGACY_SIDE_BAR_WIDTH;

const LabSideBar = (props: LabSideBarProps) => {
  const hasPortfolioLabFF = useHasFF('portfolio_lab_ff');
  return hasPortfolioLabFF ? <LabSideBarNew {...props} /> : <LabSideBarLegacy {...props} />;
};

export default LabSideBar;
